import React from 'react';

type DividerProps = {
  color?: string;
};

export function Divider({ color = 'var(--color-gray-20)' }: DividerProps) {
  return (
    <svg fill='none' height='1' viewBox='0 0 33 1' width='33' xmlns='http://www.w3.org/2000/svg'>
      <g id='Divider'>
        <line id='line' stroke={color} x1='0.300781' x2='32.3008' y1='0.5' y2='0.5' />
      </g>
    </svg>
  );
}
